import styled from 'styled-components'
import tw from 'twin.macro'
import { Page } from '@/components/page/Page'
import SEO from '@/utils/SEO'
import { DefaultPageStyles } from '@/styles/page'
import { BlogDetails } from '@/components/blog/BlogDetails'
import { BlogCubanSandwichFestival2024Details, BlogPropertyTaxes2024Details, BlogVoyageTampa2024Details, BlogBenTDavisBeach2024Details, BlogPropertyFraudAlertsDetails } from './blog'
import { AboutDetails } from './AboutPage'

const BlogStyling = styled(DefaultPageStyles)`
  h2 {
    ${tw`text-left!`}
  }
`

export const BlogPage = () => {
  return (
    <Page headerText='Blog'>
      <SEO 
        title='Blog | Edith Austin Realtor'
        description='Discover information about realty and events in Tampa Bay, Florida'
        type='website'
      />
      <BlogStyling>
        <BlogDetails 
          details={BlogPropertyFraudAlertsDetails}
        />
        <BlogDetails 
          details={BlogBenTDavisBeach2024Details}
        />
        <BlogDetails 
          details={BlogVoyageTampa2024Details}
        />
        <BlogDetails 
          details={BlogPropertyTaxes2024Details}
        />
        <BlogDetails 
          details={BlogCubanSandwichFestival2024Details}
        />
        <BlogDetails 
          details={AboutDetails}
        />
      </BlogStyling>
    </Page>
  )
}
